import { forwardRef, type SVGProps } from 'react';

export const Training = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.225 3.245c5.438 0 9.863 4.425 9.863 9.863 0 5.44-4.425 9.864-9.863 9.864-5.44 0-9.863-4.425-9.863-9.864 0-5.438 4.424-9.863 9.863-9.863zm0-2.818A12.664 12.664 0 00.543 13.108 12.664 12.664 0 0013.225 25.79a12.664 12.664 0 0012.68-12.682A12.664 12.664 0 0013.226.428zm0 9.863a2.814 2.814 0 00-2.818 2.818 2.814 2.814 0 002.818 2.818 2.814 2.814 0 002.818-2.818 2.814 2.814 0 00-2.818-2.818zm0-2.254c2.79 0 5.072 2.283 5.072 5.072 0 2.79-2.283 5.073-5.072 5.073-2.79 0-5.073-2.283-5.073-5.073 0-2.79 2.283-5.072 5.073-5.072zm0-2.536a7.599 7.599 0 00-7.61 7.608 7.599 7.599 0 007.61 7.61 7.599 7.599 0 007.608-7.61A7.599 7.599 0 0013.225 5.5z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
));
